<template>
  <div class="">
    <div class="page-contain">
      <div class="search-content-main">
          <el-form v-if="!isConfigurationData" class="search-content-main-fields">
              <el-form-item>
                  <el-select class="search-content-main-fields-year" placeholder="请选择" v-model="searchMainData.year" @change="handleBudgetMainSearch()">
                    <el-option v-for="item in baseDataRecords.Year" :key="item.id" :value="item.id" :label="item.yearName">
                    </el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                  <el-select class="search-content-main-fields-departId" placeholder="请选择" v-model="searchMainData.departId" @change="resetMedicalField();handleBudgetMainSearch()">
                    <el-option v-for="item in userInfo.loginDeparts" :key="item.id" :value="item.id" :label="item.departName">
                    </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item>
                  <el-select class="search-content-main-fields-medicalField" placeholder="请选择" v-model="searchMainData.medicalField" @change="resetTeamField();handleBudgetMainSearch()">
                    <el-option v-for="item in getMedicalFieldArray(searchMainData.departId)" :key="item.id" :value="item.id" :label="item.medicalFieldName">
                    </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item>
                  <el-select class="search-content-main-fields-medicalField" placeholder="请选择" v-model="searchMainData.teamL4" @change="handleBudgetMainSearch()">
                    <el-option v-for="item in getTeamArray(searchMainData.departId, searchMainData.medicalField)" :key="item.id" :value="item.id" :label="item.teamName">
                    </el-option>
                  </el-select>
              </el-form-item>
          </el-form>
          <el-form v-else class="search-content-main-fields">
              <el-form-item>
                  <el-select class="search-content-main-fields-year" placeholder="请选择" v-model="searchMainData.year" @change="handleBudgetMainSearch()">
                    <el-option v-for="item in baseDataRecords.Year" :key="item.id" :value="item.id" :label="item.yearName">
                    </el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                  <el-select class="search-content-main-fields-departId" placeholder="请选择" v-model="searchMainData.departId" @change="resetMedicalField();handleBudgetMainSearch()">
                    <el-option v-for="item in departsList" :key="item.id" :value="item.id" :label="item.departName">
                    </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item>
                  <el-select class="search-content-main-fields-medicalField" placeholder="请选择" v-model="searchMainData.medicalField" @change="resetTeamField();handleBudgetMainSearch()">
                    <el-option v-for="item in medicalFieldList" :key="item.id" :value="item.id" :label="item.medicalFieldName">
                    </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item>
                  <el-select class="search-content-main-fields-medicalField" placeholder="请选择" v-model="searchMainData.teamL4" @change="handleBudgetMainSearch()">
                    <el-option v-for="item in teamList" :key="item.id" :value="item.id" :label="item.teamName">
                    </el-option>
                  </el-select>
              </el-form-item>
          </el-form>
        <div v-if="!editMainBudget" class="main-edit" @click="handleMainEdit">
          <i class="l-user-item-icon iconfont icon-bianji"></i>
          <label>编辑年度/季度预算</label>
        </div>
        <div v-else class="main-edit">
          <el-button type="text" class="main-edit-cancle" @click="handleCancleMainEditClick()">
            取消
          </el-button>
          <el-button type="text" @click="handleConfirmMainEditClick()">
            确定
          </el-button>
        </div>
      </div>
      <div class="page-contain-main-tab">
        <div class="main-blocks">
          <div class="main-block">
            <div class="main-block-contain">
              <div class="main-block-contain-title">年度</div>
              <div class="main-block-contain-budget">
                <i class="iconfont icon-qiandaizi"></i>
                <label v-if="!editMainBudget">￥{{mainData.yearBudgAmt | MoneyFormat}}</label>
                <cny-input v-else v-model="mainData.yearBudgAmt"></cny-input>
              </div>
            </div>
          </div>
          <div class="main-block">
            <div class="main-block-contain">
              <div class="main-block-contain-title">一季度</div>
              <div class="main-block-contain-budget">
                <i class="iconfont icon-qianbao"></i>
                <label v-if="!editMainBudget">￥{{mainData.q1BudgAmt | MoneyFormat}}</label>
                <cny-input v-else v-model="mainData.q1BudgAmt"></cny-input>
              </div>
            </div>
          </div>
          <div class="main-block">
            <div class="main-block-contain">
              <div class="main-block-contain-title">二季度</div>
              <div class="main-block-contain-budget">
                <i class="iconfont icon-qianbao"></i>
                <label v-if="!editMainBudget">￥{{mainData.q2BudgAmt | MoneyFormat}}</label>
                <cny-input v-else v-model="mainData.q2BudgAmt"></cny-input>
              </div>
            </div>
          </div>
          <div class="main-block">
            <div class="main-block-contain">
              <div class="main-block-contain-title">三季度</div>
              <div class="main-block-contain-budget">
                <i class="iconfont icon-qianbao"></i>
                <label v-if="!editMainBudget">￥{{mainData.q3BudgAmt | MoneyFormat}}</label>
                <cny-input v-else v-model="mainData.q3BudgAmt"></cny-input>
              </div>
            </div>
          </div>
          <div class="main-block">
            <div class="main-block-contain">
              <div class="main-block-contain-title">四季度</div>
              <div class="main-block-contain-budget">
                <i class="iconfont icon-qianbao"></i>
                <label v-if="!editMainBudget">￥{{mainData.q4BudgAmt | MoneyFormat}}</label>
                <cny-input v-else v-model="mainData.q4BudgAmt"></cny-input>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="page-contain-tab">
        <div class="content-box">
          <div class="search-content">
              <el-form class="search-content-fields">
                <el-form-item>
                    <el-select v-model="searchData.quarter">
                        <el-option value="" label="全部季度"></el-option>
                        <el-option v-for="item in baseDataRecords.Quarter" :key="item.value" :value="item.value" :label="item.text">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select @change="handleSearchCostCenterChange" v-model="searchData.costCenter">
                        <el-option value="" label="全部成本中心"></el-option>
                        <el-option v-for="item in costCenterArray" :key="item.costId" :value="item.costId" :label="item.costName">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="searchData.wbsCode">
                        <el-option value="" label="全部WBS code"></el-option>
                        <el-option v-for="item in wbsCodeArray" :key="item.costId" :value="item.costId" :label="item.costName">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="handleSearch()">搜索</el-button>
                </el-form-item>
              </el-form>
          </div>
          <div>
            <div class="budget-detail-info">预算拆分总计{{budgetDetailCount}}条&nbsp;共：{{budgetDetailAmt | MoneyFormat}}</div>
            <div class="operate">
              <div>
                <a :href="'/static/file/budget.xlsx?t='+new Date().getTime()">
                  <el-button type="primary" plain>导出模板</el-button>
                </a>
                <span>
                  <common-upload
                    :importApi="crudApi"
                    importType="Excel"
                    :onSuccess="handleUpdateSuccess"
                  >
                    <el-button type="primary" plain>批量上传</el-button>
                  </common-upload>
                </span>
                <el-button :disabled="!mainData.id" type="primary" @click="handlerExportExcelClick()" plain>批量导出</el-button>
                <el-button :disabled="!mainData.id || selectedData.length <= 0 " type="primary" @click="handleBatchDeleteClick()" plain>批量删除</el-button>
                <el-button :disabled="!mainData.id" type="primary" @click="handleAddNewClick()">添加预算拆分</el-button>
              </div>
            </div>
          </div>
          <common-crud ref="crud"
            :addNewOrEditData="addNewOrEditData"
            :searchData="searchData"
            :crudApi="crudApi"
            :tableData.sync="budgetDetailData"
            :showEditFormTitle="false"
            :beforeSave="beforeSave"
            editDialogClass="biz-budget-detail-edit-dialog"
            :handleSearchResult="handleSearchResult"
            :selectedDataArray.sync="selectedData"
            :afterSave="handleBudgetChange"
            :afterDelete="handleBudgetChange"
            :defaultPageSize="10"
            addSuccessMessages="添加预算拆分成功"
            editSuccessMessages="编辑预算拆分成功"
            deleteSuccessMessages="删除预算拆分成功"
            deleteBatchSuccessMessages="批量删除预算拆分成功"
          >
            <template slot="result">
              <el-table-column type="selection" width="55">
              </el-table-column>
              <el-table-column type="index" :index="indexMethod" width="60" label="序号">
              </el-table-column>
              <el-table-column sortable prop="departId" label="部门">
              </el-table-column>
              <el-table-column sortable prop="medicalField" width="135">
                <template slot="header" slot-scope="scope">
                  <div style="display:inline-block">
                    <div>Franchise/DA</div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column sortable prop="teamL4" label="团队" width="150">
              </el-table-column>
              <el-table-column :formatter="formatBaseData" sortable prop="prodIds" label="产品">
              </el-table-column>
              <el-table-column :formatter="formatBaseData" sortable prop="quarter" label="季度">
              </el-table-column>
              <el-table-column sortable prop="companyCode" label="法律实体" width="120">
              </el-table-column>
              <el-table-column sortable prop="costType" label="类型" width="120">
                <template slot-scope="scope">
                  {{ scope.row.costType === '1' ? '成本中心' : scope.row.costType === '2' ? 'Real Wbs Code' : '' }}
                </template>
              </el-table-column>
              <el-table-column sortable prop="costCenter" label="成本中心" width="120">
              </el-table-column>
              <el-table-column sortable prop="wbsCode" label="WBS code" width="130">
              </el-table-column>
              <el-table-column sortable prop="budgAmt" label="季度预算拆分金额" width="160">
                <template slot-scope="scope">
                  {{ scope.row.budgAmt | MoneyFormat }}
                </template>
              </el-table-column>
              <el-table-column :formatter="formatDateTime2Date" sortable prop="updateTime" label="更新时间" width="120">
              </el-table-column>
              <el-table-column sortable prop="updateBy" label="操作人" width="100">
              </el-table-column>
              <el-table-column fixed="right" label="操作" width="110">
                <template slot-scope="scope">
                  <div class="table-column-operate">
                    <el-button type="text" @click="handleEditClick(scope.row)">
                      编辑
                    </el-button>
                    <el-button type="text" @click="handleDeleteClick(scope.row)">
                      删除
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </template>
            <template slot="customTitle">预算拆分</template>
            <template slot="editForm">
              <el-row>
                  <el-col>
                      <el-form-item required label="部门" prop="departId">
                          <el-select disabled placeholder="请选择" v-model="addNewOrEditData.departId">
                              <el-option v-for="item in userInfo.loginDeparts" :key="item.id" :value="item.id" :label="item.departName">
                              </el-option>
                          </el-select>
                      </el-form-item>
                  </el-col>
                  <el-col>
                      <el-form-item required label="Franchise/DA" prop="medicalField">
                          <el-select disabled placeholder="请选择" v-model="addNewOrEditData.medicalField">
                              <el-option v-for="item in userInfo.loginMedicalFields" :key="item.id" :value="item.id" :label="item.medicalFieldName">
                              </el-option>
                          </el-select>
                      </el-form-item>
                  </el-col>
                  <el-col>
                      <el-form-item required label="团队" prop="teamL4">
                          <el-select disabled placeholder="请选择" v-model="addNewOrEditData.teamL4">
                              <el-option v-for="item in userInfo.loginTeams" :key="item.id" :value="item.id" :label="item.teamL4">
                              </el-option>
                          </el-select>
                      </el-form-item>
                  </el-col>
              </el-row>
              
              <el-row>
                  <el-col>
                      <el-form-item :rules="[{ required: true, trigger: 'change' }]" label="产品" prop="prodIds">
                          <el-select filterable :disabled="isEdit" multiple placeholder="请选择（可多选，可搜索）" v-model="addNewOrEditData.prodIds">
                              <el-option v-for="item in baseDataRecords.Product" :key="item.id" :value="item.id" :label="item.productName">
                              </el-option>
                          </el-select>
                      </el-form-item>
                  </el-col>
                  <el-col>
                      <el-form-item required label="所在年份" prop="year">
                          <el-select disabled placeholder="请选择" v-model="addNewOrEditData.year">
                              <el-option v-for="item in baseDataRecords.Year" :key="item.id" :value="item.id" :label="item.yearName">
                              </el-option>
                          </el-select>
                      </el-form-item>
                  </el-col>
                  <el-col>
                      <el-form-item required label="所在季度" prop="quarter">
                          <el-select :disabled="isEdit" placeholder="请选择" v-model="addNewOrEditData.quarter">
                              <el-option v-for="item in baseDataRecords.Quarter" :key="item.value" :value="item.value" :label="item.text">
                              </el-option>
                          </el-select>
                      </el-form-item>
                  </el-col>
              </el-row>
              
              <!-- 类型字段 - 编辑时禁用，新增时可修改并触发方法 -->
              <el-row>
                  <el-col>
                      <el-form-item required label="类型" prop="costType">
                          <el-select 
                            :disabled="isEdit" 
                            placeholder="请选择" 
                            v-model="addNewOrEditData.costType" 
                            @change="handleCostTypeChange"
                          >
                              <!-- 确保value和label正确对应 -->
                              <el-option :value="1" label="成本中心"></el-option>
                              <el-option :value="2" label="Real Wbs Code"></el-option>
                          </el-select>
                      </el-form-item>
                  </el-col>
                  <!-- 法律实体字段 - 放在类型后面，编辑时不可修改 -->
                  <el-col>
                      <el-form-item required label="法律实体" prop="companyCode">
                          <el-select 
                            filterable 
                            :disabled="isEdit" 
                            placeholder="请选择" 
                            v-model="addNewOrEditData.companyCode" 
                            @change="handleCompanyCodeChange"
                          >
                              <el-option v-for="item in companyCodeArray" :key="item.value" :value="item.text" :label="item.text"></el-option>
                          </el-select>
                      </el-form-item>
                  </el-col>
              </el-row>
              
              <!-- 当选择类型1时显示的成本中心相关字段 - 编辑时也要显示 -->
              <el-row v-if="addNewOrEditData.costType === 1">
                  <el-col>
                      <el-form-item 
                        label="成本中心" 
                        prop="costCenter"
                        :rules="[
                          { required: addNewOrEditData.costType === 1, message: '请选择成本中心', trigger: 'change' }
                        ]"
                      >
                          <el-select 
                            clearable 
                            filterable 
                            remote 
                            :remote-method="handleCostCenter4EditFilter" 
                            @change="handleEditCostCenterChange(); addNewOrEditData.costCenterName = getNameFromArray(filterCostCenter4EditArray,'costCenter', 'description', addNewOrEditData.costCenter);filterCostCenter4EditArray=[]" 
                            :disabled="isEdit" 
                            placeholder="请使用ASPIRE新的成本中心" 
                            v-model="addNewOrEditData.costCenter"
                          >
                              <el-option v-for="item in filterCostCenter4EditArray" :key="item.costCenter" :value="item.costCenter" :label="item.costCenter">
                              </el-option>
                          </el-select>
                      </el-form-item>
                  </el-col>
                  <el-col>
                      <el-form-item label="成本中心owner" prop="owner">
                          <span class="tooltip-header-text" slot="label">成本中心owner<common-tooltip tipCode="14"></common-tooltip></span>
                          <el-select 
                            @change="addNewOrEditData.ownerName = getName(addNewOrEditData.owner, remoteOwnerArray, 'username', 'realname'); remoteOwnerArray=[];addNewOrEditData.isMedicalField=addNewOrEditData.owner?addNewOrEditData.isMedicalField:false"  
                            filterable 
                            remote 
                            :remote-method="handleOwnerFilter" 
                            clearable 
                            :disabled="isEdit"
                            placeholder="请输入" 
                            v-model="addNewOrEditData.owner"
                          >
                              <el-option v-for="item in remoteOwnerArray" :key="item.username" :value="item.username" :label="item.realname+' '+item.username">
                              </el-option>
                          </el-select>
                          <div class="isMedicalField" hidden>
                            <el-checkbox :disabled="!addNewOrEditData.owner" v-model="addNewOrEditData.isMedicalField">本franchise成员可使用</el-checkbox>
                          </div>
                      </el-form-item>
                  </el-col>
              </el-row>
              
              <!-- WBS code字段（根据类型显示不同样式） -->
              <el-row>
                  <el-col>
                      <el-form-item 
                        label="WBS code" 
                        prop="wbsCode"
                        :rules="[
                          { required: addNewOrEditData.costType === 2, message: '请选择WBS code', trigger: 'change' }
                        ]"
                      >
                          <!-- 类型1：保持原来的下拉选择样式 -->
                          <el-select 
                            v-if="addNewOrEditData.costType === 1"
                            filterable 
                            clearable 
                            @change="addNewOrEditData.wbsCodeName = getNameFromArray(wbsCode4EditArray,'wbsElement', 'description', addNewOrEditData.wbsCode)" 
                            :disabled="isEdit" 
                            placeholder="请使用ASPIRE新的WBS Code" 
                            v-model="addNewOrEditData.wbsCode"
                          >
                              <el-option v-for="item in wbsCode4EditArray" :key="item.wbsElement" :value="item.wbsElement" :label="item.wbsElement">
                              </el-option>
                          </el-select>
                          
                          <!-- 类型2：改为远程搜索样式（像成本中心那样） -->
                          <el-select 
                            v-else
                            filterable 
                            clearable
                            remote
                            :remote-method="handleWbsCodeRemoteFilter"
                            @change="handleWbsCodeChange"
                            :disabled="isEdit" 
                            placeholder="请使用ASPIRE新的WBS Code" 
                            v-model="addNewOrEditData.wbsCode"
                          >
                              <el-option v-for="item in filterWbsCode4EditArray" :key="item.wbsElement" :value="item.wbsElement" :label="item.wbsElement">
                              </el-option>
                          </el-select>
                      </el-form-item>
                  </el-col>
                  <el-col>
                      <el-form-item :rules="[{ required: true, trigger: 'blur' }]" label="季度预算拆分金额" prop="budgAmt">
                          <cny-input v-model="addNewOrEditData.budgAmt"></cny-input>
                      </el-form-item>
                  </el-col>
              </el-row>
            </template>
            <template slot="confirmAddNewMessage">
              <div>
                <span>确认添加预算拆分？</span>
              </div>
            </template>
            <template slot="confirmEditMessage">
              <div>
                <span>确认保存预算拆分？</span>
              </div>
            </template>
            <template slot="confirmDeleteMessage">
              <div>
                <span>删除预算拆分？</span>
              </div>
            </template>
            <template slot="confirmBatchDeleteMessage">
              <div>
                <span>批量删除预算拆分？</span>
              </div>
            </template>
          </common-crud>
        </div>
      </div>
    </div>
    <!-- 确认保存预算 -->
    <el-dialog class="main-edit-confirm" title="预算管理" width="400px" :show-close="false" :visible.sync="confirmEditMainBudgetSaveVisible" :close-on-click-modal="false">
        <div class="main-budget-info">
          <div class="main-budget-info-block">
            <div class="main-budget-info-block-name"><label>年度预算：</label></div>
            <div class="main-budget-info-block-value">{{mainData.yearBudgAmt | MoneyFormat}}</div>
          </div>
          <div class="main-budget-info-block">
            <div class="main-budget-info-block-name"><label>一季度预算：</label></div>
            <div class="main-budget-info-block-value">{{mainData.q1BudgAmt | MoneyFormat}}</div>
          </div>
          <div class="main-budget-info-block">
            <div class="main-budget-info-block-name"><label>二季度预算：</label></div>
            <div class="main-budget-info-block-value">{{mainData.q2BudgAmt | MoneyFormat}}</div>
          </div>
          <div class="main-budget-info-block">
            <div class="main-budget-info-block-name"><label>三季度预算：</label></div>
            <div class="main-budget-info-block-value">{{mainData.q3BudgAmt | MoneyFormat}}</div>
          </div>
          <div class="main-budget-info-block">
            <div class="main-budget-info-block-name"><label>四季度预算：</label></div>
            <div class="main-budget-info-block-value">{{mainData.q4BudgAmt | MoneyFormat}}</div>
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="handlerEditMainBudgetSaveConfirmOK()">确定</el-button>
          <el-button @click="confirmEditMainBudgetSaveVisible = false">取消</el-button>
        </div>
    </el-dialog>
  </div>
</template>

<script>
import costCenterAndWbs from '@/api/costCenterAndWbs';
import budget from '@/api/bizmanagement/budget';
import bizmanagement from '@/api/bizmanagement/index';
import externalprivilege from '@/api/sysmanagement/externalprivilege';
import basedata from '@/api/basedata';
import { mapGetters, mapActions } from 'vuex';
import { getItem, setItem } from '@/util/SessionStorageService';
import * as orgUtil from '@/util/organizationUtil'

export default {
  data() {
    return {
      isConfigurationData:true,
      departsList :[],
      medicalFieldList :[],
      teamList :[],
      budgetDetailData :[],
      searchMainData: {
        year: '',
        departId: '',
        medicalField: '',
        teamL4: '',
      },
      searchData: {
        quarter:'',
        costCenter: '',
        wbsCode: '',
        pid: '',
      },
      addNewOrEditData: {
        costType: 1, // 默认值为1
        companyCode: '', // 法律实体，默认取登录用户法律实体
        departId: '',
        medicalField: '',
        teamL4: '',
        prodIds: [],
        year: '',
        quarter: '',
        costCenter: '',
        costCenterName: '',
        wbsCode: '',
        wbsCodeName: '',
        budgAmt: 0,
        isMedicalField: '',
        owner: '',
        ownerName: '',
      },
      mainData: {},
      mainDataTemp: {},
      crudApi: budget,
      editMainBudget: false,
      confirmEditMainBudgetSaveVisible: false,
      isEdit: false,
      budgetDetailCount: 0,
      budgetDetailAmt: 0,
      selectedData: [],
      companyCodeArray: [], // 法律实体字典数据(company_code)
      costCenterArray: [],
      wbsCodeArray: [],
      costCenter4EditArray: [],
      wbsCode4EditArray: [],
      filterCostCenter4EditArray: [],
      filterWbsCode4EditArray: [], // 新增：用于远程搜索过滤的WBS code数组
      allWbsCode4EditArray: [], // 新增：存储所有WBS code数据
      remoteOwnerArray: [],
      filterCostCenterByQuarter: null, //null 代表没有查询；空字符串代码没有记录需过滤
      retryExternalCostCenterArray: 3,
    }
  },
  computed: {
    ...mapGetters(['userInfo','baseDataRecords','basedataGetName','basedataGetNameByRowIdField']),
  },
  methods: {
    ...mapActions(['initBaseDataByTypes']),
    getMedicalFieldArray(departId) {
      return orgUtil.franchiseArray(departId);
    },
    getTeamArray(departId, medicalField) {
      return orgUtil.teamArray(departId, medicalField);
    },
    resetMedicalField() {
      this.searchMainData.medicalField = (this.baseDataRecords.Organization[0][this.searchMainData.departId][0] || {}).id;
      this.resetTeamField();
    },
    resetTeamField() {
      let medicalList = this.baseDataRecords.Organization[0][this.searchMainData.departId];
      for (let i = 0; i < medicalList.length; i++) {
        if (medicalList[i].id == this.searchMainData.medicalField) {
          this.searchMainData.teamL4 = (medicalList[i].teams[0] || {}).id;
          return;
        }
      }
    },
    formatDateTime2Date(row, column, cellValue, index) {
      return this.$refs['crud'].formatDateTime2Date(row, column, cellValue, index);
    },
    formatBaseData(row, column, cellValue, index) {
      if(column.property == 'prodIds'){
          if(row.prodIds) {
            let ids = row.prodIds;
            if(typeof ids == 'string') {
              ids =  ids.split(',');
            }
            let prodNames = []
            for (let pidIndex = 0; pidIndex < ids.length; pidIndex++) {
              prodNames.push(this.basedataGetName('Product', ids[pidIndex]));
            }
            return prodNames.join(',')
          }
          return row.prodIds;
      }

      return this.basedataGetNameByRowIdField(column.property, row);
    },
    indexMethod(index) {
      return this.$refs['crud'].indexMethod(index);
    },
    handleSearch() {
      this.$refs['crud'].handleSearch(1);
    },
    handleSearchResult(res) {
      this.budgetDetailCount = res.rowCount;
      this.budgetDetailAmt = res.sumBudgAmt;

      res.current = res.pageList.current;
      res.total = res.pageList.total;

      this.budgetDetailData = res.pageList.records;
    },
    handleAddNewClick() {
      this.wbsCode4EditArray = [];
      this.allWbsCode4EditArray = []; // 清空 allWbsCode4EditArray
      this.isEdit = false; // 设置为新增模式
      this.filterCostCenterByQuarter = null;
      
      // 先调用handleAddNew
      this.$refs['crud'].handleAddNew(this.mainData);
      this.addNewOrEditData.budgAmt = 0
      
      // 设置默认类型为1，并且确保类型切换方法可以被触发
      this.$nextTick(() => {
        this.addNewOrEditData.costType = 1;
        // 默认法律实体为登录用户法律实体
        this.addNewOrEditData.companyCode = this.userInfo.companyCode;
        // 如果需要加载相关数据
        this.loadExternalCostCenter();
      });
    },
    handleEditClick(item) {
      item.isMedicalField = item.isMedicalField == '1';
      this.isEdit = true; // 设置为编辑模式
      if(typeof item.prodIds == 'string'){
        item.prodIds = item.prodIds.split(',');
      }
      
      // 确保 costType 是数字类型，而不是字符串
      if (item.costType !== undefined) {
        item.costType = Number(item.costType); // 转换为数字，确保与option的value匹配
      }
      
      // 根据 costType 设置不同的数据
      if (item.costType === 1) {
        this.filterCostCenter4EditArray = [{
          costCenter: item.costCenter,
          description: item.costCenterName
        }];
        this.wbsCode4EditArray = [{
          wbsElement: item.wbsCode,
          description: item.wbsCodeName
        }];
        
        // 如果有owner，设置owner相关数据
        if (item.owner) {
          this.remoteOwnerArray = [{
            username: item.owner,
            realname: item.ownerName || item.owner
          }];
        }
      } else {
        // 类型2：设置 WBS code 相关数据
        this.allWbsCode4EditArray = [{
          wbsElement: item.wbsCode,
          description: item.wbsCodeName
        }];
        // 清空成本中心相关数据
        this.filterCostCenter4EditArray = [];
        this.remoteOwnerArray = [];
      }
      
      this.$refs['crud'].handleEdit(item);
      this.$nextTick(() => {
        if (item.costType === 1) {
          // 重新加载完整的成本中心列表和WBS code列表
          this.loadExternalCostCenter();
        } else {
          // 重新加载完整的 WBS code 列表
          this.loadExternalWbsCode();
        }
        
        // 强制刷新选择器的显示
        if (this.$refs['crud'] && this.$refs['crud'].$refs.editForm) {
          this.$refs['crud'].$refs.editForm.clearValidate();
        }
      });
    },
    beforeSave(saveData) {
      saveData.pid = this.mainData.id;
      saveData.prodIds = saveData.prodIds.join(',');
      saveData.isMedicalField = saveData.isMedicalField?'1':'0'
    },
    handleDeleteClick(item) {
      this.$refs['crud'].handleDelete(item);
    },
    handleBatchDeleteClick() {
      this.$refs['crud'].handleBatchDelete();
    },
    handlerExportExcelClick() {
      this.$refs['crud'].handlerExportExcel('预算拆分.xlsx');
    },
    handleUpdateSuccess() {
      this.handleSearch();
    },
    handleMainEdit() {
      this.editMainBudget = true;
    },
    handleCancleMainEditClick() {
      this.mainData = _.clone(this.mainDataTemp);
      this.editMainBudget = false;
    },
    handleConfirmMainEditClick() {
      this.confirmEditMainBudgetSaveVisible = true;
    },
    handlerEditMainBudgetSaveConfirmOK() {
      if(!this.mainData.id) {
        this.mainData.year = this.searchMainData.year;
        this.mainData.departId = this.searchMainData.departId;
        this.mainData.medicalField = this.searchMainData.medicalField;
        this.mainData.teamL4 = this.searchMainData.teamL4;
      }
      budget.editMainBudget(this.mainData)
            .then(res => {
              this.$message.success('编辑年度/季度预算成功');
              this.mainDataTemp = _.clone(this.mainData);
              this.confirmEditMainBudgetSaveVisible = false;
              this.editMainBudget = false;

              this.handleBudgetMainSearch()
            })
    },
    handleBudgetMainSearch() {
      budget.queryMainBudget(this.searchMainData)
          .then(res => {
            res.teamL4 = this.searchMainData.teamL4;
            this.mainData = res;
            if(!this.mainData.id) {
              this.mainData = {
                  "yearBudgAmt": 0,
                  "q1BudgAmt": 0,
                  "q2BudgAmt": 0,
                  "q3BudgAmt": 0,
                  "q4BudgAmt": 0
              }
            }
            this.mainDataTemp = _.clone(this.mainData);

            this.searchData.quarter = '';
            this.searchData.costCenter =  '';
            this.searchData.wbsCode =  '';
            this.searchData.pid =  this.mainData.id;

            this.budgetDetailCount = 0;
            this.budgetDetailAmt = 0;

            if(!this.searchData.pid) {
              //没有数据，直接清空table数据
              this.budgetDetailData = [];
            }
            else {
              this.handleSearch();
           }
          })
    },
    getNameFromArray(arr, idField, nameField, id){
      if(arr) {
        for (let index = 0; index < arr.length; index++) {
          const element = arr[index];
          if(element[idField] == id) {
            return element[nameField];
          }
        }
      }

      return '';
    },
    handleSearchCostCenterChange() {
      this.searchData.wbsCode = ''
      this.wbsCodeArray = [];

      if(!this.searchData.costCenter) {
          return;
      }

      costCenterAndWbs.listLocalWbsCode(
                    {
                      companyCode: this.userInfo.companyCode,
                      costCenter: this.searchData.costCenter
                    }
                  )
                  .then(res => {
                    this.wbsCodeArray = res;
                  })

    },
    handleEditCostCenterChange() {
      this.addNewOrEditData.wbsCode = ''
      this.addNewOrEditData.wbsCodeName = ''
      this.wbsCode4EditArray = [];

      if(!this.addNewOrEditData.costCenter) {
          return;
      }
      costCenterAndWbs.listExternalWbsCode(
                    {
                      companyCode: this.addNewOrEditData.companyCode,
                      costCenter: this.addNewOrEditData.costCenter,
                      costType: 1
                    }
                  )
                  .then(res => {
                    this.wbsCode4EditArray = res;
                  })

    },
    handleCostCenter4EditFilter(query) {
      if(!query) {
            this.filterCostCenter4EditArray = [];
            return;
      }

    this.filterCostCenter4EditArray = this.costCenter4EditArray.filter(item => {
        const description = item.description ? item.description.toLowerCase() : '';
        const costCenter = item.costCenter ? item.costCenter.toLowerCase() : '';
        const queryLower = query ? query.toLowerCase() : '';
        
        return description.indexOf(queryLower) > -1 || costCenter.indexOf(queryLower) > -1;
      });
    },
    // 新增：WBS code远程搜索过滤方法
    handleWbsCodeRemoteFilter(query) {
      if (!query) {
        this.filterWbsCode4EditArray = [];
        return;
      }

      // 从 allWbsCode4EditArray 中过滤匹配的数据
      this.filterWbsCode4EditArray = this.allWbsCode4EditArray.filter(item => {
        const queryLower = query ? query.toLowerCase() : '';
        return (item.description && item.description.toLowerCase().indexOf(queryLower) > -1) ||
              (item.wbsElement && item.wbsElement.toLowerCase().indexOf(queryLower) > -1);
      });
    },
    
    // 新增：WBS code变更处理方法
    handleWbsCodeChange() {
      // 当选择WBS code后，保存对应的描述信息
      this.addNewOrEditData.wbsCodeName = this.getNameFromArray(
        this.allWbsCode4EditArray, 
        'wbsElement', 
        'description', 
        this.addNewOrEditData.wbsCode
      );
      // 清空过滤数组，避免显示过多选项
      this.filterWbsCode4EditArray = [];
    },
    handleOwnerFilter(query) {
      if(!query) {
            this.remoteOwnerArray = [];
            return;
      }

      this.remoteOwnerArray = [];

      externalprivilege.getEdcByAd({
              ad:query
            })
            .then(res => {
              if(res && res.username) {
                this.remoteOwnerArray = [res];
              }
            })
    },
    getName(value, array, idField, nameField) {
        for (let index = 0; index < array.length; index++) {
            const element = array[index];
            if(element[idField] == value) {
                return element[nameField];
            }
        }

        return '';
    },
    // 修改 unique 方法
    unique(arr, type = 'costCenter') {
      const res = new Map();
      if (type === 'wbs') {
        // 针对 WBS code 数据，使用 wbsElement 作为唯一标识
        return arr.filter((item) => !res.has(item.wbsElement) && res.set(item.wbsElement, 1));
      } else {
        // 针对成本中心数据，使用 costCenter 作为唯一标识
        return arr.filter((item) => !res.has(item.costCenter) && res.set(item.costCenter, 1));
      }
    },
    loadExternalCostCenter() {
      // 法律实体由表单选择决定，新增时默认登录用户法律实体
      let companyCode = this.addNewOrEditData.companyCode || this.userInfo.companyCode;
      // 缓存 key 按法律实体区分，避免切换法律实体后命中旧数据
      let cacheKey = 'budget-extenal-cost-center:' + companyCode;
      let tempArr = getItem(cacheKey);
      if(tempArr) {
        let arr1 = this.unique(tempArr);
        this.costCenter4EditArray = arr1;
        return;
      }

      this.retryExternalCostCenterArray  = this.retryExternalCostCenterArray-1;
      costCenterAndWbs.listExternalCostCenter({companyCode: companyCode})
                  .then(res => {
                    let arr1 = this.unique(res);
                    this.costCenter4EditArray = arr1;
                    setItem(cacheKey,this.costCenter4EditArray)
                  },err => {
                    if(this.retryExternalCostCenterArray > 0) {
                      this.loadExternalCostCenter();
                    }
                  })
    },
    handleBudgetChange() {
      costCenterAndWbs.listLocalCostCenter({companyCode: this.userInfo.companyCode})
                  .then(res => {
                    this.costCenterArray = res;
                  })
    },
    // 加载法律实体字典(company_code)
    loadCompanyCode() {
      basedata.listCompanyCode()
                  .then(res => {
                    this.companyCodeArray = res || [];
                  })
    },
    getCustomizationArray(arr){
      if(arr.length > 0){
        const customizationArray = arr.map(ele => {
          const data = {
            id: ele,
            teamName: ele,
          }
          return data
        });
        return customizationArray
      }else return []
    },
    // 处理类型变更
    handleCostTypeChange(value) {
        // 清空成本中心相关字段
        this.addNewOrEditData.costCenter = '';
        this.addNewOrEditData.owner = '';
        this.addNewOrEditData.ownerName = '';
        
        // 清空WBS code
        this.addNewOrEditData.wbsCode = '';
        this.addNewOrEditData.wbsCodeName = '';
        this.filterWbsCode4EditArray = []; // 清空过滤数组
        
        // 触发表单校验更新
        this.$nextTick(() => {
          if (this.$refs['crud'] && this.$refs['crud'].$refs.editForm) {
            this.$refs['crud'].$refs.editForm.clearValidate(['costCenter', 'wbsCode']);
          }
        });

        if(value == '2') {
          this.loadExternalWbsCode();
        }
        
    },

    // 处理法律实体变更：清空成本中心/WBS 已选值并按类型重新加载列表
    handleCompanyCodeChange() {
        // 清空成本中心相关字段与数组
        this.addNewOrEditData.costCenter = '';
        this.addNewOrEditData.costCenterName = '';
        this.addNewOrEditData.owner = '';
        this.addNewOrEditData.ownerName = '';
        this.filterCostCenter4EditArray = [];
        this.costCenter4EditArray = [];

        // 清空 WBS code 相关字段与数组
        this.addNewOrEditData.wbsCode = '';
        this.addNewOrEditData.wbsCodeName = '';
        this.wbsCode4EditArray = [];
        this.filterWbsCode4EditArray = [];
        this.allWbsCode4EditArray = [];

        // 触发表单校验更新
        this.$nextTick(() => {
          if (this.$refs['crud'] && this.$refs['crud'].$refs.editForm) {
            this.$refs['crud'].$refs.editForm.clearValidate(['costCenter', 'wbsCode']);
          }
        });

        // 按当前类型重新加载对应法律实体的数据
        if (this.addNewOrEditData.costType === 1) {
          this.loadExternalCostCenter();
        } else if (this.addNewOrEditData.costType === 2) {
          this.loadExternalWbsCode();
        }
    },
    
    // 修改 loadExternalWbsCode 方法
    loadExternalWbsCode() {
      // 法律实体由表单选择决定，新增时默认登录用户法律实体
      let companyCode = this.addNewOrEditData.companyCode || this.userInfo.companyCode;
      // 缓存 key 按法律实体区分，避免切换法律实体后命中旧数据
      let cacheKey = 'budget-extenal-wbs-code:' + companyCode;
      let tempArr = getItem(cacheKey);
      if(tempArr) {
        let arr1 = this.unique(tempArr, 'wbs');
        this.allWbsCode4EditArray = arr1;
        return;
      }

      costCenterAndWbs.listExternalWbsCode(
          {
            companyCode: companyCode,
            costType: 2,
            costCenter: ''
          })
          .then(res => {
            let arr1 = this.unique(res, 'wbs');
            this.allWbsCode4EditArray = arr1;
            setItem(cacheKey, this.allWbsCode4EditArray);
          });
    },

  },
  mounted() {
    bizmanagement.queryBusDataOrg().then((res) => {
      this.isConfigurationData = res.isConfigurationData
      this.searchMainData.year = (new Date()).getFullYear();
      if(this.isConfigurationData) {
        this.departsList = this.getCustomizationArray(res.departList);
        this.searchMainData.departId = res.departList.length>0 ? res.departList[0] : '';
        this.medicalFieldList = this.getCustomizationArray(res.medicalFieldList);
        this.searchMainData.medicalField = res.medicalFieldList.length>0 ? res.medicalFieldList[0] : '';
        this.teamList = this.getCustomizationArray(res.teamList);
        this.searchMainData.teamL4 = res.teamList.length>0 ? res.teamList[0] : '';
        // this.resetMedicalField();
        this.handleBudgetMainSearch();
      }else {
        this.initBaseDataByTypes(['Depart','MedicalField','Year','Quarter','Product'])
        .then(() => {
            this.searchMainData.departId = this.userInfo.loginDeparts.length>0 ? this.userInfo.loginDeparts[0].id : '';
            let tempMedicalFieldArray = this.getMedicalFieldArray(this.searchMainData.departId);
            this.searchMainData.medicalField = tempMedicalFieldArray.length>0 ? tempMedicalFieldArray[0].id : '';
            let tempTeamArray = this.getTeamArray(this.searchMainData.departId, this.searchMainData.medicalField);
            this.searchMainData.teamL4 = tempTeamArray.length>0 ? tempTeamArray[0].id : '';
            this.resetMedicalField();
            this.handleBudgetMainSearch();
        })
      }

    })
    

    this.handleBudgetChange();

    this.loadExternalCostCenter();

    this.loadCompanyCode();

  }
};
</script>

<style lang="less" scoped>
  .search-content-main {
    display: flex;
    margin-bottom: 12px;

    .search-content-main-fields {
      float:left;
      display: flex;

      .el-form-item + .el-form-item {
        margin-left: 16px;
      }

      &-year {
        width: 120px;
      }

      &-medicalField {
        width: 180px;
      }
      &-departId {
        width: 180px;
      }
    }
  }

  .main-edit {
    margin-left: auto;
    margin-top: 18px;
    cursor: pointer;

    label, i {
      font-size: 14px;
      color: @contentFontColor;
      height: 22px;
      line-height: 22px;
      cursor: pointer;
    }

    .el-button {
      height: 22px;
      color: @primaryTextButtonText;
      font-size: 14px;
    }

    .el-button.main-edit-cancle {
      height: 22px;
      color: @cancleTextButtonText;
      font-size: 14px;
    }
  }

  .search-content {
    display: flex;
    margin-bottom: 22px;
    .search-content-fields {
      float:left;
      display: flex;

      div {
        width: 180px;
      }
    }

    .el-form-item + .el-form-item {
      margin-left: 16px;
    }
  }
  .operate {
    float: right;
    margin-bottom: 30px;
  }

  .l-user-item {
    width: 100%;
    height: 57px;
    padding: 18px 22px;
    border-bottom: 1px solid #dfdfdf;
    display: flex;
    align-items: center;

    &-icon {
      font-size: 16px;
      padding: 2px;
    }
  }

  .main-blocks {
    display: flex;
    width: 100%;
    flex-flow: row nowrap;
    justify-content: space-between;
  }

  .main-block {
    height: 120px;
    width: 235px;
    display: inline-block;
    border: none;

    &-contain {
      display: inline-block;
      width: 235px;

      &-title {
        margin-left: 24px;
        margin-top: 16px;
        height: 22px;
        line-height: 22px;
        font-size: 16px;
        color: @contentFontColor
      }

      &-budget {
        margin-left: 24px;
        margin-top: 18px;
        height: 30px;
        line-height: 30px;
        font-size: 24px;
        display: flex;

        i {
          font-size: 28px;
          color: #2D82F0;
        }

        .icon-qiandaizi {
          color:#FFB52A;
        }

        label {
          color: rgba(0,0,0,0.85);
          margin-left: 16px;
        }
      }
    }
  }

  .main-block + .main-block {
    .main-block-contain {
      border-left: 1px solid #E8E8E8;
      height: 80px;
      margin-top: 20px;

      .main-block-contain-title {
        margin-top: -4px;
      }
    }
  }

  .budget-detail-info {
    float: left;
    height: 32px;
    line-height: 32px;
    font-size: @subSubFontSize;
    color: @subSubFontColor;
  }

  .main-budget-info-block {
    display: flex;
    padding-bottom: 16px;

    &-name {
      width: 50%;

      label {
        float: right;
        font-size: @contentFontSize;
        color: @contentFontColor;
      }
    }

    &-value {
      font-size: @subSubFontSize;
      color: @subSubFontColor;
    }
  }

</style>
<style lang="less">
.biz-budget-detail-edit-dialog {
  .isMedicalField {
    position: absolute;
    top: 0;
    left: 230px;
  }
  .el-checkbox__input.is-checked .el-checkbox__inner::after {
    left: 5px;
    top: 2px;
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?01cba67e